import { PageUrl } from "@/constants/url"
import './style.css'

export const ErrorBoundary = () => {
    
  return (
    <div className="general-error-page w-full bg-white flex flex-col items-center" >
      <div className="wrapper w-[91%] slg:w-[96%] slg:max-w-[940px] lg:w-[91%] min-h-[440px]">
        <div className="px-[20px] py-[50px] md:p-[100px]">
          <p className="font-thin text-gray-710 text-[24px] lg:text-[36px] font-pingFangNormal">抱歉</p>
          <p className="text-[16px] lg:text-[18px] text-gray-510 mt-[17px] mb-[32px] font-normal">
            您查找的页面暂时无法访问
          </p>
          <p>
            <a
              href={PageUrl.HOMEPAGE}
              className="before:absolute before:bottom-[11px] before:left-0 before:w-[10px] before:h-[10px] before:border-t before:border-r before:border-solid before:border-gray-710 before:scale-[0.8] before:transform before:-rotate-135 inline-block relative text-[16px] lg:text-4 pl-4 pb-[5px] text-gray-710 border-b border-solid border-gray-710 font-pingFangNormal font-medium"
            >
              回到梅赛德斯-奔驰首页
            </a>
          </p>
          <p className="mt-[54px] mb-4 text-gray-710 text-4 lg:mt-[79px] lg:mb-[21px] lg:text-[20px] font-medium font-pingFangNormal">
            由哪些可能原因导致？
          </p>
          <div className="ml-[18px]">
            <ul className="list-disc font-pingFangNormal">
              <li className="font-medium leading-[34px] text-gray-510 text-[13px] lg:text-[14px]">
                输入了错误网页地址
              </li>
              <li className="font-medium leading-[34px] text-gray-510 text-[13px] lg:text-[14px]">
                您尝试搜索的页面已删除、更名或暂不可用
              </li>
              <li className="font-medium leading-[34px] text-gray-510 text-[13px] lg:text-[14px]">程序出现故障</li>
            </ul>
          </div>
        </div>
 
      </div>
      
    </div>
  )
}
 
